import { render, staticRenderFns } from "./ArticleAdultChannelContainer.vue?vue&type=template&id=a659769c&"
import script from "./ArticleAdultChannelContainer.vue?vue&type=script&lang=js&"
export * from "./ArticleAdultChannelContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports